(function() {
    'use strict';

    angular
        .module('sodCommon')
        .run(runFunc)
        .config(laddaConfig);

    function runFunc($templateCache, $q, $rootScope, Carousel, $location, $route) {
        $rootScope.initLoader = $q.defer();
        $rootScope.templateLoader.promise.then(function() {
            // Override angular-notifier template
            $templateCache.put('src/notification.html', $templateCache.get('common/components/notifier/notification'));

            $rootScope.initLoader.resolve();
        });

        Carousel.setOptions({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            cssEase: 'ease-in-out',
            dots: false,

            easing: 'linear',
            fade: false,
            infinite: true,
            initialSlide: 1,

            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
        });

        if (window.self != window.top) {
            angular.element(document.body).addClass('is-iframe');
        }
    }

    function laddaConfig(laddaProvider) {
        laddaProvider.setOption({
            style: 'expand-left',
            spinnerSize: 25,
            spinnerColor: "#ffffff"
        });
    }
})();

